import { render, staticRenderFns } from "./SocialShareBar.vue?vue&type=template&id=613f75b3&"
import script from "./SocialShareBar.vue?vue&type=script&lang=js&"
export * from "./SocialShareBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports